import { render, staticRenderFns } from "./accountSearch.vue?vue&type=template&id=ba2460f6"
import script from "./accountSearch.vue?vue&type=script&lang=js"
export * from "./accountSearch.vue?vue&type=script&lang=js"
import style0 from "./accountSearch.vue?vue&type=style&index=0&id=ba2460f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports